var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efefef",
    width: "800px",
    height: "800px",
    viewBox: "-7 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#efefef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "zero"), /*#__PURE__*/React.createElement("path", {
    d: "M9 2c6.406 0 7.969 7 7.969 12.063s-1.563 12.063-7.969 12.063-7.719-7.063-7.719-12.063 1.281-12.063 7.719-12.063zM9.094 24.063c4.906 0 5.719-6.281 5.719-9.969 0-3.656-0.813-9.938-5.719-9.938-5.063 0-5.625 6.25-5.625 9.938s0.563 9.969 5.625 9.969z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.8892b4bdd09b34eaeb3c99c2fefa6b5a.svg";
export { ForwardRef as ReactComponent };